import StepItem, { StepItemProps } from './StepItem';

export type { StepItemProps };
export default StepItem;
